<template>
  <!-- 网吧用户管理 -->
  <div class="container">
    <!-- 管理员 -->
    <!-- <div class="user-list">
      <span class="user-head">
        <img src="@/images/userhead.png" alt srcset />
      </span>
      <span class="user-name">{{userEntity.name}}</span>
      <span class="user-jurisdiction" v-show="userEntity.isAdmin == 0">{{userEntity.duty}}</span>
    </div> -->
    <!-- 普通人员 -->
    <div class="user-list" v-for="(item,index) in list" :key="index">
      <span class="user-head">
        <img src="@/images/userhead.png" alt srcset />
      </span>
      <span class="user-name">{{item.userName}}</span>
      <span class="user-jurisdiction" v-show="item.isAdmin == 0">管理员</span>
      <span class="user-del"  @click="handleDelClick(item.id)" v-show="item.isAdmin !== 0 && userEntity.is_admin ==0 ">
        <img src="@/images/userdel.png" alt srcset />
      </span>
    </div>
    <!-- 添加人员 -->
    <div class="user-list" v-show="userEntity.is_admin == 0">
      <span class="user-head">
        <img src="@/images/useradd.png" alt srcset />
      </span>
      <span class="user-name" @click="handleGoPageAddUser" >添加人员</span>
    </div>
    <!-- 信息管理按钮 -->
    <div class="btn" @click="handleGopagesInfo" v-show="userEntity.is_admin == 0">网吧信息管理</div>
  </div>
</template>

<script>
import { Dialog,Toast } from "vant";
import { userList, deleteUser } from "@/api/user";
import { async } from "q";
export default {
  data() {
    return {
      userEntity: "",
      list: [],
      isRouterAlive: true,
      is_admin:''
    };
  },
  mounted() {
    // sessionStorage.setItem('logininfo',JSON.stringify())
    this.requestUserList();
  },
  methods: {
    // 操作删除按钮
    handleDelClick(id) {
      Dialog.confirm({
        title: "确定删除该成员"
      })
        .then(() => {
          this.requestDeleteUser(id);
        })
        .catch(() => {
          // on cancel
        });
    },
    // 跳转到添加用户列表
    handleGoPageAddUser() {
      let netBarId = this.$cookies.get('internetBarId')
      this.$router.push({
        path: "/adduser",
        query:{
          netBarId:netBarId
        }
      });
    },
    // 跳转到网吧信息管理
    handleGopagesInfo() {
      this.requestEchonNetbarInfo();
    },
    // 获取用户列表
    requestUserList() {
      let netBarId = this.$cookies.get('internetBarId')
      userList({internetBarId:netBarId}).then(res => {
        console.log(res);
        this.userEntity = res.data.userEntity;
        this.list = res.data.list;
      });
    },
    // 删除用户
    requestDeleteUser(id) {
      deleteUser({id:id }).then(res => {
        console.log(res);
        if (res.code == 200) {
          this.requestUserList();
        }else {
          Toast(res.message)
        }
      });
    },
    // 根据用户编号回显网吧信息
    requestEchonNetbarInfo() {
          this.$router.push({
            path: "/infomanagement",
          });
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  overflow-x: hidden;
  .user-list {
    width: 350px;
    height: 60px;
    line-height: 60px;
    background-color: #ffffff;
    margin: 10px auto;
    border-radius: 8px;
    box-sizing: border-box;
    text-align: left;
    font-size: 15px;
    color: #333333;
    // 用户头像
    .user-head {
      display: inline-block;
      width: 40px;
      height: 40px;
      //  margin-top: 10px;
      margin-left: 10px;
      img {
        width: 40px;
        height: 40px;
        vertical-align: middle;
      }
    }
    // 用户名称
    .user-name {
      display: inline-block;
      vertical-align: middle;
      margin: 0 10px;
      font-weight: bold;
    }
    // 用户权限
    .user-jurisdiction {
      display: inline-block;
      width: 50px;
      height: 20px;
      line-height: 21px;
      background-color: rgba($color: #008cff, $alpha: 0.2);
      color: #008cff;
      border-radius: 10px;
      font-size: 12px;
      font-weight: bold;
      text-align: center;
      vertical-align: middle;
    }
    // 用户删除按钮
    .user-del {
      float: right;
      width: 14px;
      height: 16px;
      margin-right: 15px;
      img {
        width: 14px;
        height: 16px;
      }
    }
  }
  // 确定按钮
  .btn {
    width: 350px;
    height: 44px;
    background: -webkit-linear-gradient(left, #05aefc, #008cff);
    margin: 0 auto;
    border-radius: 22px;
    font-size: 16px;
    color: $white-color;
    line-height: 44px;
    margin: 0 auto;
    margin-top: 99px;
  }
}
</style>
